import { Link } from 'react-router-dom';

export default function PortalsSection() {
  return (
    <section className="sec">
      <div className="wrap">
        <div className="hd2 rv">
          <div>
            <small>만드는 사람도, 사용하는 사람도 편리하게</small>
            <h2>
              관리자와 사용자,
              {' '}
              <em>각자 역할</em>
              에 맞춘 환경
            </h2>
          </div>
        </div>
        <div data-tabs="" className="rv d1">
          <div className="ptabrow">
            <div className="ptab">
              <button className="on" data-t="a">관리자 포탈</button>
              <button data-t="u">사용자 포탈</button>
            </div>
            <Link className="more" to="/product#s1">
              자세히보기
              <svg className="i">
                <use href="#arr" />
              </svg>
            </Link>
          </div>
          <div className="ppan on" data-p="a">
            <div className="txt gp">
              <small style={{ color: "var(--ac)" }}>ADMIN PORTAL</small>
              <h3>
                사내 지식을 연결하고,
                <br />
                AI Agent를 만들어보세요.
              </h3>
              <p>AI Agent를 만들고 운영하는 관리자 공간</p>
              <ul>
                <li>
                  <svg className="i" style={{ color: "var(--ac)" }}>
                    <use href="#ccheck" />
                  </svg>
                  지식베이스 구축
                </li>
                <li>
                  <svg className="i" style={{ color: "var(--ac)" }}>
                    <use href="#ccheck" />
                  </svg>
                  워크플로우 구성
                </li>
                <li>
                  <svg className="i" style={{ color: "var(--ac)" }}>
                    <use href="#ccheck" />
                  </svg>
                  AI Agent 테스트 및 배포
                </li>
                <li>
                  <svg className="i" style={{ color: "var(--ac)" }}>
                    <use href="#ccheck" />
                  </svg>
                  사용자 및 시스템 관리
                </li>
              </ul>
            </div>
            <div className="vis2 gp">
              <div className="shot">
                <img src="/site/home/admin-dashboard.png" alt="" />
              </div>
              <div className="ui" style={{ right: "28px", bottom: "28px", width: "240px", zIndex: "2" }}>
                <div className="uih">
                  <b>지식베이스 · 워크플로우 · 배포 관리</b>
                </div>
                <div style={{ display: "flex", gap: "6px", padding: "0 16px 14px" }}>
                  <span className="bdg p">지식베이스</span>
                  <span className="bdg b">워크플로우</span>
                  <span className="bdg g">배포</span>
                </div>
              </div>
            </div>
          </div>
          <div className="ppan" data-p="u">
            <div className="txt gm">
              <small style={{ color: "#14A3AD" }}>USER PORTAL</small>
              <h3>
                필요한 AI를 선택하고,
                <br />
                업무에 바로 활용하세요.
              </h3>
              <p>AI Agent를 쓰고 지식·업무 흐름을 만드는 사용자 공간</p>
              <ul>
                <li>
                  <svg className="i" style={{ color: "var(--teal)" }}>
                    <use href="#ccheck" />
                  </svg>
                  배포된 AI Agent 탐색·대화
                </li>
                <li>
                  <svg className="i" style={{ color: "var(--teal)" }}>
                    <use href="#ccheck" />
                  </svg>
                  최근 대화 이력
                </li>
                <li>
                  <svg className="i" style={{ color: "var(--teal)" }}>
                    <use href="#ccheck" />
                  </svg>
                  지식베이스 생성·관리
                </li>
                <li>
                  <svg className="i" style={{ color: "var(--teal)" }}>
                    <use href="#ccheck" />
                  </svg>
                  워크플로우·템플릿 활용
                </li>
              </ul>
            </div>
            <div className="vis2 gm">
              <div className="shot">
                <img src="/site/screens/user-dashboard.png" alt="" />
              </div>
              <div className="ui" style={{ right: "28px", bottom: "28px", width: "240px", zIndex: "2" }}>
                <div className="uih">
                  <b>AI 대화 · 지식베이스 · 워크플로우</b>
                </div>
                <div style={{ display: "flex", gap: "6px", padding: "0 16px 14px" }}>
                  <span className="bdg g">AI 대화</span>
                  <span className="bdg p">지식베이스</span>
                  <span className="bdg b">워크플로우</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
